/**
 * 通达信内置浏览器联动工具
 */

/**
 * 触发通达信联动跳转
 * @param {string} symbolCode 股票代码，格式如 "002222.SZ" 或 "601869.SH"
 */
export function tdxLinkStock(symbolCode) {
    if (!symbolCode) return;
    
    try {
        const isTdx = /Tdx/i.test(navigator.userAgent) || 
                      (window.external && (window.external.Tdx_Call || window.external.Tdx_GetMyName || typeof window.external.SelectStock === 'function'));
        
        if (isTdx || window.TDX_API) {
            const parts = symbolCode.split('.');
            const code = parts[0];
            const suffix = parts[1] || '';
            
            let market = '0'; // 默认深市
            if (suffix === 'SH') market = '1';
            else if (suffix === 'BJ') market = '2';
            
            console.log(`[TdxLink] Executing linkage for: ${code} (Market: ${market})`);

            // 1. 优先尝试 API 调用 (最稳定，且不会引起页面跳转)
            if (window.external) {
                if (window.external.Tdx_Call) {
                    try {
                        window.external.Tdx_Call("SelectStock", market, code, 1);
                        return; // 如果成功，直接结束，防止后续协议触发报错
                    } catch (e) {
                        console.warn('[TdxLink] Tdx_Call failed');
                    }
                }
                if (typeof window.external.SelectStock === 'function') {
                    try {
                        window.external.SelectStock(code, market);
                        return; // 成功则结束
                    } catch (e) {
                        console.warn('[TdxLink] SelectStock failed');
                    }
                }
            }

            // 2. 协议跳转回退 (使用隐藏 Iframe，防止页面报“找不到网页”错误)
            const triggerViaIframe = (url) => {
                const iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = url;
                document.body.appendChild(iframe);
                setTimeout(() => {
                    if (document.body.contains(iframe)) document.body.removeChild(iframe);
                }, 1000);
            };

            // 依次触发（带微小延迟，防止冲突）
            setTimeout(() => triggerViaIframe(`http://www.treeid/code=${code}&market=${market}`), 10);
            setTimeout(() => triggerViaIframe(`stockcode:${code}`), 100);
            
            const fullTdxCode = (market === '1' ? 'SH' : 'SZ') + code;
            setTimeout(() => triggerViaIframe(`stockcode:${fullTdxCode}`), 200);
            
            return true; // 表示已在通达信环境下处理
        }
    } catch (e) {
        console.error('[TdxLink] Linkage failed:', e);
    }
    return false; // 表示不是通达信环境，或者处理失败
}
